module.exports = __webpack_public_path__ + "static/1-828ba77cb0322e1c22927f335b0fcd68.jpg";